<template>
  <section
    class="slider"
    data-anim="slider"
  >
    <div
      class="slider__viewport"
      :style="{ transform: `translate3d(0, ${amount}%, 0)` }"
      @mouseleave="hover"
    >
      <router-link
        v-for="motorcycle in data"
        :key="motorcycle.id"
        class="slider__item"
        :data-id="motorcycle.id"
        :data-detail="`${motorcycle.detail.country} . ${motorcycle.detail.year}`"
        :to="`/esposizione/${motorcycle.id}`"
        @mouseenter.native="hover"
        @mouseleave.native="hover"
      >
        <h1>
          {{ motorcycle.brand }} <span>. {{ motorcycle.name }}</span>
        </h1>
      </router-link>
    </div>

    <div class="slider__figure" ref="figure">
      <div class="slider__filler" style="opacity: 0;"></div>
      <svg width="800" height="567">
        <filter id="distortionFilter">
          <feTurbulence type="fractalNoise" baseFrequency="0.01 0.003" numOctaves="5" seed="2" stitchTiles="noStitch" x="0%" y="0%" width="100%" height="100%" result="noise"/>
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="0" xChannelSelector="R" yChannelSelector="B" x="0%" y="0%" width="100%" height="100%" filterUnits="userSpaceOnUse"/>
        </filter>
        <g filter="url(#distortionFilter)">
          <transition
            @enter="enter"
            @leave="leave"
            mode="in-out"
          >
            <image
              class="slider__img"
              :key="active"
              v-if="active"
              x="50"
              y="50"
              :xlink:href="`/static/images/${active}/00_${active}.jpg`"
              width="700"
              height="467"
              preserveAspectRatio="xMidYMid slice"
              image-rendering="optimizeQuality"
            />
          </transition>
        </g>
      </svg>
    </div>
  </section>
</template>

<script>
import apollo from '@/scripts/apollo';
import utils from '@/scripts/utils';

export default {
  name: 'Slider',

  data() {
    return {
      amount: 0,
      filter: 0,
      active: null,
    };
  },

  props: {
    data: {
      type: Array,
      required: true,
    },
  },

  mounted() {
    if (!utils.isTouchDevice()) {
      window.addEventListener('apollo-update', this.currentPosition);
      this.items = Array.from(this.$el.querySelectorAll('.slider__item'));
      this.filter = document.querySelector('feDisplacementMap');
    }
  },

  beforeDestroy() {
    window.removeEventListener('apollo-update', this.currentPosition);
  },

  methods: {
    currentPosition(event) {
      if (document.querySelector('.app__inner').dataset.page === 'motorcycle') return;

      const { y, x } = event.detail;
      this.amount = (y / window.innerHeight) * -50;
      const velocity = Math.min(apollo.ref.velocity.y * 100, 80);
      this.filter.scale.baseVal = velocity;

      const top = Math.max(
        0,
        Math.min(
          y - (this.$refs.figure.getBoundingClientRect().height / 2),
          this.$refs.figure.getBoundingClientRect().height / 2,
        ),
      );
      this.$refs.figure.style.top = `${top}px`;

      this.$refs.figure.style.left = `${x + 30 - (this.$refs.figure.getBoundingClientRect().width / 2) - document.querySelector('aside.left').getBoundingClientRect().width}px`;
    },

    hover(event) {
      if (utils.isTouchDevice()) return;
      const dir = event.type === 'mouseenter';

      if (dir) {
        this.$store.commit('SET_DETAIL', event.target.dataset.detail);
        this.active = event.target.dataset.id;

        this.items.forEach((el) => {
          if (el.dataset.id !== event.target.dataset.id) {
            el.classList.add('not-hovered');
          } else {
            el.classList.remove('not-hovered');
          }
        });
      } else {
        this.$store.commit('SET_DETAIL', null);
        this.active = null;
        this.items.forEach(el => el.classList.remove('not-hovered'));
      }
    },

    enter(el, done) {
      // this.$refs.figure.style.left = `${window.innerWidth * 0.35 - document.querySelector('aside.left').getBoundingClientRect().width}px`;
      done();
    },

    leave(el, done) {
      done();
    },
  },
};
</script>

<style lang="scss" scoped>
.slider {
  position: relative;

  @include mq($and: $is-hover) {
    padding-top: 25vh;
    height: calc(100vh - #{rem(60px)});
  }

  @include mq($and: $is-touch-device) {
    padding: rem(40px) 0 rem(40px) 0;
  }

  &__viewport {
    position: relative;
  }

  &__item {
    position: relative;
    display: block;
    overflow: hidden;

    transition: opacity 0.2s ease-out 0.1s;

    padding-bottom: rem(5px);

    &:hover {
      opacity: 1;
    }

    &.not-hovered {
      opacity: 0.1;
    }
  }

  &__figure {
    position: absolute;
    width: 75%;

    pointer-events: none;

    z-index: -1;

    opacity: 0.7;

    // @media (prefers-color-scheme: dark) {
    //   opacity: 1;
    // }

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__picture {
    position: relative;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: 50% 50%;
  }

  &__filler {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    pointer-events: none;

    background: RGB($color-bg);
    mix-blend-mode: multiply;

    @at-root body[data-theme="day"] & {
      mix-blend-mode: unset;

      @media (prefers-color-scheme: light) {
        mix-blend-mode: multiply;
      }
    }

    /* @media (prefers-color-scheme: light) {
      mix-blend-mode: unset;
    } */
  }
}
h1 {
  pointer-events: none;
  margin: 0;
}
</style>
